import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { DoubleYaxisVisualmaplineService } from './double-yaxis-visualmapline.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';

@Component({
  selector: 'bcac-double-yaxis-visualmap-line',
  templateUrl: './double-yaxis-visualmap-line.component.html',
  styleUrls: ['./double-yaxis-visualmap-line.component.scss']
})
export class DoubleYaxisVisualmapLineComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private lineService: DoubleYaxisVisualmaplineService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: '图表标题'
  };

  // 布局设置
  // cardpadding
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = '';

  // eachrt图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis: EChartOption.XAxis[] = this.lineService.getChartxAxis();
  chartyAxis: EChartOption.YAxis[] = this.chartOptionService.getChartyAxis(2);
  chartTextStyle: EChartOption.TextStyle = this.chartOptionService.getTextStyle();
  chartVisualMap = this.lineService.getPiecewiseVisualMap();
  lineChartSeries: EChartOption.Series = this.lineService.getDefaultLineSeries();
  chartTooltip: EChartOption.Tooltip = this.lineService.getAxisChartWithMultiDimensionTooltip();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitles,
    legend: this.chartLegend,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    visualMap: this.chartVisualMap,
    tooltip: this.chartTooltip,
    color: this.chartColors,
    series: this.chartSeriesList,
    textStyle: this.chartTextStyle
  }

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;

  onOptionInit(ec) {
    this.optionInit = ec;
  }

  options;
  // echart配置项
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }

  // 属性输入区
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.lineService.changeChartTitleDark(this, darkMode);
    this.lineService.chartBackgroundColorDarkMode(this.chartOption);
    this.lineService.xAxisDarkMode(this.chartxAxis);
    this.lineService.yAxisDarkMode(this.chartyAxis);
    this.lineService.colorsDarkMode(this.chartColors);
    this.lineService.legendDarkMode(this.chartLegend);
    this.lineService.seriesDarkMode(this.lineChartSeries);
  }

  // dimension
  @Input()
  set bcacDimensionName(dimensionName: string[]) {
    this.lineService.setSeriesDimensionName(this.lineChartSeries, dimensionName, this.chartTooltip);
  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.lineService.setSmallModeGrid(this.chartGrid);
      this.lineService.setSmallModePadding(this);
    }
  }

  legendPosition: string = 'right';
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.lineService.setLegendPosition(this.chartGrid, this.chartLegend, legendPosition)
  }

  @Input()
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }
  @Input()
  set bcacXaxisName(xAxisname: string) {
    this.lineService.setXaxisName(this.chartxAxis, xAxisname);
  }
  @Input()
  set bcacYaxisName(yAxisName: string[]) {
    this.lineService.setYaxisName(this.chartyAxis, yAxisName);
  }
  @Input()
  set bcacYnameGap(yNameGap: number[]) {
    this.lineService.setYnameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.lineService.chartColorsChange(this.chartColors, colorList);
  }


  legendDataList;
  @Input()
  set bcacChartData(chartData: any) {
    let legendDataList = [];
    if (chartData && chartData.hasOwnProperty('data') && chartData.data.hasOwnProperty('seriesName')) {
      chartData.data.seriesName.forEach(e => {
        legendDataList.push(
          {
            label: e.name,
            value: e.name,
            checked: true
          }
        )
      })
    }
    this.legendDataList = legendDataList;
    this.lineService.buildSeries(chartData, this.chartVisualMap, this.chartSeriesList, this.chartxAxis, this.lineChartSeries)
    this.updateOption();
  }

  legendChange(e) {
    this.lineService.topLegendChange(e, this.optionInit);
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  // x轴刻度间隔
  intervalData = [];
  intervalSelectedData;
  intervalSelectedDataChange(e: any) {
    this.lineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  axisScaleChange(e: any) {
    this.lineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  @Input()
  set bcacIntervalData(value: any[]) {
    this.intervalData = value;
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacYAxisMin(yAxisMin: number[]) {
    this.lineService.setYAxisMin(yAxisMin, this.chartyAxis);
  }

  @Input()
  set bcacYAxisMax(yAxisMax: number[]) {
    this.lineService.setYAxisMax(yAxisMax, this.chartyAxis);
  }

  @Input()
  set bcacYAxisInterval(yAxisInterval: number) {
    this.lineService.setYAxisInterval(yAxisInterval, this.chartyAxis)
  }

  @Input()
  set bcacYAxisMinInterval(minInterval: number[]) {
    this.lineService.setYAxisMinInterval(this.chartyAxis, minInterval)
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInit, this.options)
    })
  }

}
